<template>
  <div class="product-selector__dropdown" v-bind:class="{ disabled: this.question.disabled }">
    <v-collapse-wrapper v-on:beforeToggle="toggleCollapsed">

      <h3>{{question.phrase}}</h3>
      <tooltip
        :question="question"
        v-if="question.showTooltip()"
      ></tooltip>

      <div v-collapse-toggle ref="collapseToggle">
        <svg role="presentation">
          <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#svg--arrow"></use>
        </svg>
      </div>
      <div v-collapse-content>

        <select
          v-model="selectedAnswerId"
          @change="notifyOfChange"
          >
          <option value="">Please select...</option>
          <option
            v-for="answer in question.answers"
            :key="answer.id"
            :value="answer.id"
            :disabled="isDisabled(answer)"
            >{{answer.phrase}}
          </option>
        </select>

      </div>

    </v-collapse-wrapper>
  </div>
</template>

<script>
  import Tooltip from '../tooltip.vue';
  import VueCollapse from 'vue2-collapse';

  export default {
    components: {
      Tooltip,
      VueCollapse
    },
    props: ['question',
            'initialSelectedAnswerId'],
    data: function() {
      return {
        collapsed: false,
        selectedAnswerId: this.initialSelectedAnswerId
      }
    },
    methods: {
      isDisabled: function(answer) {
        return ((answer.disabled && (this.selectedAnswerId !== answer.id)) || (this.question.disabled));
      },
      notifyOfChange() {
        this.$emit('notify-answers-changed', this.question.id, this.selectedAnswerId);
      },
      toggleCollapsed: function() {
        this.collapsed = !this.collapsed;
        this.$refs.collapseToggle.classList.toggle('collapsed');
      },
    },
    watch: {
      initialSelectedAnswerId: function() {
        // this watch method is required so reset can change the parent's data - and this value will be re-assigned
        this.selectedAnswerId = this.initialSelectedAnswerId;
      }
    },
  }
</script>
